import React from "react";
export function SwipeablePanelBackdrop(props) {
    const style = {
        position: "fixed",
        top: 0, left: 0, height: "100vh", width: "100vw",
        zIndex: 3000, backgroundColor: "rgba(0,0,0,0.7)"
    }
    return (<div style={style} {...props}>{props.children}</div>)
}